<template>
    <div class="ur-data-grid__edit__dropdown__items" :style="posStyle">
        <div class="ur-data-grid__edit__dropdown__item" :class="itemClass(item)"
                v-for="(item, idx) in items" @click="clickItem(item)" :key="idx">
            <span>{{item.text||item.value||item}}</span>
        </div>
    </div>
</template>

<script>
import anchorMixin from "./urDataGridAnchorMixin";
// TODO 1. key.enter to save?
export default {
    name : 'urDataGridEditDropdownItems',
    mixins : [anchorMixin],
    props : {
        value : [String,Number,Object],
        items : {type:Array, default:() => []},
    },
    data() { return {
        currVal: '', // value for "input" element
    }},
    computed : {
        itemMap() {
            var map = new Map();
            if(!this.items) return map;
            this.items.forEach(it => {
                map.set(it.value,it);
            })
            return map;
        }
    },
    watch : {
        value: {immediate: true, handler(val, old) { 
            this.currVal = val; // when input comes
        }}
    },
    methods : {
        clickItem(item) {
            var v = item.value === undefined ? item : item.value;
            this.$emit('input',v)
        },
        getText(val) {
            var item = this.itemMap.get(val);
            return (item?item.text:null) || val;
        },
        itemClass(item) {
            if((item.value||item) === this.value) {
                return 'ur-data-grid__edit__dropdown__item-label--selected';
            }
            return null;
        }
    },
};
</script>
